module.exports = __webpack_public_path__ + "img/spin.7d44403c.svg";